import {
  BlockingDialog,
  BlockingDialogContent,
  BlockingDialogHeader,
  BlockingDialogTitle,
  BlockingDialogDescription,
} from "@/components/ui/blocking-dialog";
import { Button } from "@/components/ui/button";
import { Lock, Sparkles, Check } from "lucide-react";

interface HardPaywallModalProps {
  open: boolean;
  onLogin: () => void;
}

const HardPaywallModal = ({ open, onLogin }: HardPaywallModalProps) => {
  const features = [
    "Crie até 10 versões da sua marca",
    "Download em alta qualidade (PNG)",
    "Paleta de cores profissional (4 cores)",
    "Kit de tipografia completo (3 fontes)",
    "Fundo transparente e colorido",
    "Suporte humano via WhatsApp",
  ];

  return (
    <BlockingDialog open={open}>
      <BlockingDialogContent className="sm:max-w-md">
        <BlockingDialogHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
            <Lock className="w-8 h-8 text-primary" />
          </div>
          <BlockingDialogTitle className="text-2xl">
            Você está quase lá!
          </BlockingDialogTitle>
          <BlockingDialogDescription className="text-base mt-2">
            Sua marca está pronta. Faça login para desbloquear o download e criar até 10 variações.
          </BlockingDialogDescription>
        </BlockingDialogHeader>

        <div className="space-y-4 mt-6">
          <div className="bg-muted/50 rounded-lg p-4 space-y-3">
            <p className="font-medium text-sm text-foreground flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-primary" />
              O que você recebe:
            </p>
            <ul className="space-y-2">
              {features.map((feature) => (
                <li key={feature} className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Check className="w-4 h-4 text-primary flex-shrink-0" />
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          <Button 
            onClick={onLogin} 
            className="w-full h-12 text-base gap-2"
          >
            Continuar e Desbloquear
          </Button>

          <p className="text-xs text-center text-muted-foreground">
            Já tem uma conta? Faça login para continuar criando.
          </p>
        </div>
      </BlockingDialogContent>
    </BlockingDialog>
  );
};

export default HardPaywallModal;
